module.exports = __webpack_public_path__ + "img/category-skill-game-hover.2d9d7a73.png";